// Company contact details (footer and Contact page) and the Contact page copy. Built-in defaults; editable in the
// portal under Website Content. The registered office in the footer is legal text and stays in Footer.jsx.
export const CONTACT_DETAILS = {
  email: 'hello@voip2.co.uk',
  phone: '+44 204 575 2222',
  addressStreet: '167-169 Great Portland Street',
  addressLocality: '5th Floor, London, W1W 5PF',
  addressCountry: 'United Kingdom',
  footerBlurb: 'Global VoIP solutions for businesses. Reliable, scalable, and secure telecommunications services.',
};

export const CONTACT_PAGE = {
  title: 'Get in Touch',
  sub: "Have questions? We're here to help. Reach out to our team and we'll respond as soon as possible.",
  hours: {
    weekdays: '9:00 AM - 6:00 PM',
    saturday: '10:00 AM - 4:00 PM',
    sunday: 'Closed',
    note: '24/7 Emergency Support Available',
  },
};
